import { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";
import styled, { css } from "styled-components";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    label: string;
    variant?: "primary" | "secondary";
    ghost?: boolean;
    block?: boolean;
    suffixIcon?: any;
    prefixIcon?: any;
  };

const StyledButton = styled.button<ButtonProps>`
  border: 0;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  align-items: center;
  justify-content: center;
  font-size: var(--nf-font-m);
  font-weight: 600;
  line-height: 1.5;
  text-decoration: none;
  display: ${({ block }) => (block ? "flex" : "inline-flex")};

  svg {
    width: 24px;
    height: 24px;
    &.suffix {
      margin-left: 10px;
    }
    &.prefix {
      margin-right: 10px;
    }
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ variant }) => css`
    background-color: var(--nf-${variant});
    color: var(--nf-on-${variant});
    :hover:not([disabled]) {
      background-color: rgba(var(--nf-${variant}-base), 0.9);
    }
  `}
  ${({ ghost, variant }) =>
    ghost &&
    css`
      color: var(--nf-${variant});
      background-color: var(--nf-on-${variant});
      :hover:not([disabled]) {
        background-color: rgba(0, 0, 0, 0.05);
      }
    `}
`;

/**
 * Primary UI component for user interaction
 */
const Button = (args: ButtonProps & { as?: "a" }) => {
  const SuffixIcon = args.suffixIcon;
  const PrefixIcon = args.prefixIcon;
  const children = (
    <>
      {args.prefixIcon && <PrefixIcon className={"prefix"} />}
      {args.label}
      {args.suffixIcon && <SuffixIcon className={"suffix"} />}
    </>
  );
  return <StyledButton {...args}>{children}</StyledButton>;
};

const defaultProps = {
  variant: "primary",
};

Button.defaultProps = defaultProps;

export default Button;
